module.exports = __webpack_public_path__ + "static/img/pe-banner.62a6550.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/activity-page/pe-banner.png
// module id = yEvI
// module chunks = 0